module.exports = __webpack_public_path__ + "media/common/images/badges/active/vytrvalec-f007e634d988b4d0c8022c2e96539123.svg";